import { type Allocation, type FileModel, type User } from '@zocks-communications/client-sdk-js'
import { FileKind } from '../../../models/File'

export const addUniqueById = <T extends { id: string }>(items: T[], item: T): T[] =>
  items.some((existing) => existing.id === item.id) ? items : [...items, item]

export const findOriginalAllocation = (originalAllocations: Allocation[] | null, transcriptionParticipantId: string): Allocation | null =>
  originalAllocations?.find((a) => a.userId === transcriptionParticipantId || a.transcriptDesignation === transcriptionParticipantId) ?? null

export const resolveInitialRealParticipantId = (originalAllocations: Allocation[] | null, users: User[], transcriptionParticipantId: string): string | null => {
  if (!originalAllocations?.length) {
    return users.some((u) => u.id === transcriptionParticipantId) ? transcriptionParticipantId : null
  }
  const allocation = findOriginalAllocation(originalAllocations, transcriptionParticipantId)
  if (!allocation) {
    return null
  }
  const { userId, name } = allocation
  const user = users.find((u) => u.id === userId) ?? users.find((u) => u.name === name)
  return user?.id ?? null
}

export const isEnhancedAllocatedSessionTranscription = (file: FileModel) => {
  const fileMetadata = JSON.parse(file.metadata)
  return file.kind === FileKind.TRANSCRIPTION && fileMetadata.transcriptionType === 'session' && fileMetadata.enhanced && !fileMetadata.unknownParticipants
}
